import { removeLike, setLike } from "app/likeReducers";
import WishlistService from "app/services/wishlistService";
import { RootState } from "app/store";
import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";

export interface LikeButtonProps {
  className?: string;
  liked?: boolean;
  id?: number
}
export interface LikeState {
  id: String
}
const LikeButton: React.FC<LikeButtonProps> = ({
  className = "",
  liked = false,
  id = 0
}) => {

  const [isLiked, setIsLiked] = useState(false);
  const likes = useSelector<RootState, [number]>( (state: RootState) => state.likeReducer )

  const dispatch = useDispatch()
  

    useEffect(() => {
      
     

      try{
          if(likes.includes(id )){
              setIsLiked(true)
          }else{
            setIsLiked(false)
          }
      }catch{
        setIsLiked(false)
      }
     
  }, [id])
  const likeHandler = (event: any) => {

      WishlistService.setWishlist(id).then(data =>{



            if(data.product_id){

        

                setIsLiked(true)
                dispatch(setLike(id))
            }
            if(data.like){

              setIsLiked(false)
              dispatch(removeLike(id))
          
              
            }


      })



  }
  return (
    <button id={'like-'+{id}}
      className={`w-9 h-9 flex items-center justify-center rounded-full bg-white dark:bg-slate-900 text-neutral-700 dark:text-slate-200 nc-shadow-lg ${className}`}
      onClick={likeHandler}
      >
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
        <path
          d="M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z"
          stroke={isLiked ? "#ef4444" : "currentColor"}
          fill={isLiked ? "#ef4444" : "none"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
    );
};

export default LikeButton;
